function ensureTrailingSlash(url) {
  const value = String(url || "").trim();
  if (!value) {
    return "/";
  }
  return value.endsWith("/") ? value : `${value}/`;
}

export const API_BASE = ensureTrailingSlash(
  process.env.REACT_APP_API_BASE
);

export const AUTH_ENDPOINTS = Object.freeze({
  login: "auth/login/",
  refresh: "auth/refresh/",
  logout: "auth/logout/",
  changePassword: "auth/change-password/",
  passwordResetVerify: "auth/password-reset/verify/",
  passwordResetConfirm: "auth/password-reset/confirm/",
  me: "auth/me/",
  invites: "auth/invites/",
  invitesValidate: "auth/invites/validate/",
  invitesAccept: "auth/invites/accept/",
});

export const ACCOUNTS_ENDPOINTS = Object.freeze({
  invites: "api/accounts/invites/",
  users: "accounts/users/",
});

export const SALE_ENDPOINTS = Object.freeze({
  sales: "api/sales/",
  salesConfirmCart: "api/sales/confirm-cart/",
  salesPendingCount: "api/sales/pending-count/",
  salesConfig: "api/sales/sales-config/",
  salesPosStart: "api/sales/pos/start/",
  salesReservationRelease: "api/sales/reservations/release/",
  salesReservationReleaseAll: "api/sales/reservations/release-all/",
  salesReservationCleanupExpired: "api/sales/reservations/cleanup-expired/",
});

export const INVOICE_ENDPOINTS = Object.freeze({
  settings: "api/invoice/settings/",
  pending: "api/invoice/pending/",
  pendingFromSale: "api/invoice/pending/from-sale/",
  documents: "api/invoice/documents/",
});

export const CASH_ENDPOINTS = Object.freeze({
  cashRegisters: "cash/registers/",
  cashSessionsCurrent: "cash/sessions/current/",
  cashSessionsRelevant: "cash/sessions/relevant/",
  cashSessionsOpenNotice: "cash/sessions/open-notice/",
  cashSessionsOpen: "cash/sessions/open/",
  cashSessionsBase: "cash/sessions/",
  cashSessionReceiveSuffix: "receive/",
  cashMovements: "cash/movements/",
});

export const INVENTORY_ENDPOINTS = Object.freeze({
  inboundNotes: "api/inbound-notes/",
  outboundNotes: "api/outbound-notes/",
  countSettings: "api/count-settings/",
  stockCounts: "api/stock-counts/",
  stockMovements: "api/stock-movements/",
  stocks: "api/stocks/",
});

export const PRODUCTS_ENDPOINTS = Object.freeze({
  products: "api/products/",
  productsCreateFull: "api/products/create-full/",
  productBarcodesSuffix: "barcodes/",
  productCategories: "api/product-categories/",
  productBrands: "api/product-brands/",
  productFamilies: "api/product-families/",
  productFormats: "api/product-formats/",
});

export const CUSTOMER_ENDPOINTS = Object.freeze({
  customers: "api/customers/",
  customersByPhone: "api/customers/lookup-by-phone/",
  customerContactsSuffix: "contacts/",
});

export const GROOMING_ENDPOINTS = Object.freeze({
  customerLookupByPhone: "api/grooming/customers/lookup-by-phone/",
  customerQuickCreate: "api/grooming/customers/quick-create/",
  pets: "api/grooming/pets/",
  appointmentContext: "api/grooming/appointment-context/",
  config: "api/grooming/config/",
  serviceTypes: "api/grooming/service-types/",
  appointments: "api/grooming/appointments/",
  appointmentAvailability: "api/grooming/appointments/availability/",
  orders: "api/grooming/orders/",
});

export const LOCATION_ENDPOINTS = Object.freeze({
  departments: "api/location/departments/",
  cities: "api/location/cities/",
});

export const REPORTS_ENDPOINTS = Object.freeze({
  productsProfit: "api/reports/products-profit/",
  salesProfit: "api/reports/sales-profit/",
  salesByDate: "api/reports/sales-by-date/",
});

export const HOME_ENDPOINTS = Object.freeze({
  dashboard: "api/home/dashboard/",
});

export const RBAC_ENDPOINTS = Object.freeze({
  companies: "rbac/companies/",
  companiesMine: "rbac/companies/mine/",
  roles: "rbac/roles/",
  permissions: "rbac/permissions/",
});
